var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStashArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 19.4,
    height: 19.4,
    rx: 3.7,
    stroke: "black",
    strokeOpacity: 0.24,
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4703 15.4432C10.3528 15.5597 10.194 15.625 10.0286 15.625C9.86319 15.625 9.70445 15.5597 9.58694 15.4432L5.42028 11.2766C5.35887 11.2194 5.30962 11.1504 5.27546 11.0737C5.2413 10.997 5.22293 10.9143 5.22145 10.8303C5.21997 10.7464 5.23541 10.6631 5.26684 10.5852C5.29828 10.5074 5.34506 10.4367 5.40441 10.3774C5.46376 10.318 5.53446 10.2712 5.61228 10.2398C5.6901 10.2084 5.77346 10.1929 5.85738 10.1944C5.9413 10.1959 6.02406 10.2143 6.10073 10.2484C6.17739 10.2826 6.24639 10.3318 6.30361 10.3932L9.40361 13.4932L9.40361 5.00158C9.40361 4.83582 9.46946 4.67684 9.58667 4.55963C9.70388 4.44242 9.86285 4.37658 10.0286 4.37658C10.1944 4.37658 10.3533 4.44242 10.4706 4.55963C10.5878 4.67684 10.6536 4.83582 10.6536 5.00158L10.6536 13.4932L13.7536 10.3932C13.8721 10.2828 14.0288 10.2227 14.1907 10.2256C14.3526 10.2285 14.5071 10.294 14.6216 10.4086C14.7361 10.5231 14.8017 10.6776 14.8046 10.8395C14.8074 11.0014 14.7473 11.1581 14.6369 11.2766L10.4703 15.4432Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStashArrowUp);
export default __webpack_public_path__ + "static/media/stash_arrow-up.dae7687be31ed6ede600bf6d4f3a517e.svg";
export { ForwardRef as ReactComponent };